/**
 * @file routes/_app/audit-tasks/route.tsx
 * @description 稽核任務 Layout 路由。
 *
 * 所有 /audit-tasks/* 子路由的佈局容器。
 * 不含額外佈局元素，直接渲染 <Outlet />。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/audit-tasks')({
  component: AuditTasksLayout,
});

function AuditTasksLayout() {
  return <Outlet />;
}
